import React, { useEffect, useMemo, useRef, useState } from "react";
import debounce from "lodash/debounce";
import { Select, Spin } from "antd";
import PropTypes from "prop-types";

function AsyncSelect({
  keyReload,
  fetchOptions,
  debounceTimeout = 500,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);
  const onSearch = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((result) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(result);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  useEffect(() => {
    onSearch();
  }, [keyReload]);

  return (
    <Select
      {...props}
      labelInValue
      allowClear
      autoClearSearchValue
      showSearch
      filterOption={false}
      onSearch={onSearch}
      onClear={onSearch}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      style={{
        width: "100%",
      }}
    />
  );
}

AsyncSelect.propTypes = {
  keyReload: PropTypes.any,
  fetchOptions: PropTypes.func.isRequired,
  debounceTimeout: PropTypes.number,
};

export default AsyncSelect;
